export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20art%20background%20with%20warm%20coral%20and%20amber%20tones%2C%20dynamic%20flowing%20shapes%20inspired%20by%20comic%20book%20energy%20lines%2C%20soft%20gradients%2C%20artistic%20texture%2C%20warm%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20abstract%20expressionist%20style%2C%20cinematic%20lighting%2C%20depth%20of%20field%2C%20elegant%20composition&width=1600&height=900&seq=manwa-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-300 text-sm"></i>
              <span className="text-primary-200 text-sm font-medium">连载漫画追更免费看</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
              漫蛙漫画网
              <br />
              漫画追更与漫画最新更新
            </h1>

            <p className="text-lg md:text-xl text-white/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              追漫画更新速度快的专业追更平台，漫画最新更新第一时间呈现。覆盖热门连载漫画追更，支持个性化追更提醒，不错过任何一话精彩内容。
            </p>

            <p className="text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              无论你追逐的是热血少年漫、悬疑推理还是恋爱日常，漫蛙漫画网为你聚合全网连载漫画更新动态，从日更到周更，一键掌握所有追更漫画的最新进度。
            </p>

            <p className="text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              当前热门主题：国漫崛起专题、日漫经典重温、新番开坑指南 —— 海量漫画追更资源持续更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">3000+</div>
                <div className="text-sm text-white/60 mt-1">连载漫画追踪</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">每日更新</div>
                <div className="text-sm text-white/60 mt-1">更新速度保障</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">全题材</div>
                <div className="text-sm text-white/60 mt-1">内容覆盖范围</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 whitespace-nowrap text-base cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索热门话题
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold rounded-full border border-white/30 transition-all duration-200 whitespace-nowrap text-base cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看人气热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/15 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20digital%20illustration%20of%20dynamic%20comic%20reading%20experience%2C%20floating%20colorful%20manga%20panels%20with%20action%20lines%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20modern%20flat%20design%20with%20geometric%20elements%2C%20energetic%20composition%2C%20artistic%20style%2C%20clean%20background%2C%20cinematic%20lighting&width=800&height=1000&seq=manwa-hero-visual&orientation=portrait"
                alt="漫蛙漫画网 - 漫画追更体验"
                className="relative w-full h-auto max-h-[500px] object-contain rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}